<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini" @submit.native.prevent="onSubmit">
            <el-form-item label="用户：" class="query-form-item">
                <el-input v-model="filter.username" placeholder="请输入用户名|账号" style="width:150px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit" native-type="submit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :height="tableHeight"
            :data="list"
            size="mini"
            stripe border style="width: 100%">
            <el-table-column
                label="用户id"
                align="center"
                width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="250"
                align="center"
                label="用户账号">
                <template slot-scope="scope">
                    <span>{{ scope.row.username }}</span>
                </template>
            </el-table-column>

            <el-table-column
                width="200"
                align="center"
                label="用户名">
                <template slot-scope="scope">
                    <span>{{ scope.row.full_name }}</span>
                </template>
            </el-table-column>

            <el-table-column
                    width="130"
                    align="center"
                    label="状态">
                <template slot-scope="scope">
                    <span>{{ scope.row.status == 0 ? '禁用' :  '正常'}}</span>
                </template>
            </el-table-column>

            <el-table-column
                width="120"
                align="center"
                label="手机号">
                <template slot-scope="scope">
                    <span>{{ scope.row.tel }}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="200"
                align="center"
                label="Email">
                <template slot-scope="scope">
                    <span>{{ scope.row.email }}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="200"
                align="center"
                label="微信号">
                <template slot-scope="scope">
                    <span>{{ scope.row.wechat }}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="200"
                align="center"
                label="qq号">
                <template slot-scope="scope">
                    <span>{{ scope.row.qq }}</span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="130"
                align="center"
                label="备注">
                <template slot-scope="scope">
                    <span v-if="scope.row.manager_remark" class="chcek_group" @click="onRemarks(scope.row)">{{ scope.row.manager_remark }}</span>
                    <el-tag style="cursor: pointer;" v-else type="info" @click="onRemarks(scope.row)">暂无备注</el-tag>
                </template>
            </el-table-column>

<!--            <el-table-column-->
<!--                label="操作"-->
<!--                fixed="right"-->
<!--                width="360">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button style="margin: 4px 0 4px 8px;padding: 7px 7px;" type="primary" size="mini" @click.native="topups(scope.row)">充值</el-button>-->
<!--                    <el-button style="margin: 4px 0 4px 8px;padding: 7px 7px;" type="primary" size="mini" @click.native="lineOfCredit(scope.row)">信用额度</el-button>-->
<!--                    <el-button style="margin: 4px 0 4px 8px;padding: 7px 7px;" type="success" size="mini" @click.native="omRechargerecord(scope.row)">充值记录</el-button>-->
<!--                    <el-button style="margin: 4px 0 4px 8px;padding: 7px 7px;" type="success" size="mini" @click.native="onSetUp(scope.row)">设置</el-button>-->
<!--                    <el-button style="margin: 4px 0 4px 8px;padding: 7px 7px;" size="mini" @click.native="viewMonitoring(scope.row)">查看监控产品</el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>
        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            :current-page="query.page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total">
        </el-pagination>
        <add :visible="ctrl.addDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></add>
        <attributes :visible="ctrl.attributesDialogVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></attributes>
        <user-info :visible="ctrl.userinfoVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></user-info>
        <remarks :visible="ctrl.remarksVisible" :formData="formData" :title="ctrl.dialogTitle" @close-callback="closeCllback"></remarks>
        <credit :visible="ctrl.acreditVisible" :formData="formData" :title="ctrl.dialogTitle" :credit="creditindex" @close-callback="closeCllback"></credit>
    </div>
</template>

<script>
import * as api from "@/api/user/user";
import * as apis from "@/api/auth/register";
import Add from "./addtow";
import Remarks from "./remarks";
import userInfo from "./userinfo";
import Credit from "./credit";
import Attributes from "./attributes";
export default {
    components: {
        Add,
        Credit,
        userInfo,
        Remarks,
        Attributes
    },
    data() {
        return {
            tableHeight: null,
            ctrl: {
                addDialogVisible: false,
                userinfoVisible: false,
                remarksVisible: false,
                attributesDialogVisible: false,
                acreditVisible: false
            },
            formData: {},
            loading: false,
            query: {
                page: 1,
                limit: 20
            },
            filter: {},
            list: [],
            creditindex: "0"
        };
    },
    created() {
        this.getList();
    },
    methods: {
        //获取列表数据
        getList() {
            const obj = Object.assign(this.query, this.filter)
            this.loading = true;
            api.users(obj).then(res => {
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                        this.loading = false;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 20,
                total: 0
            };
            this.filter = {};
            this.getList();
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getList();
        },
        //充值
        topups(data) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.ctrl.dialogTitle = data.username + " 充值";
            this.ctrl.addDialogVisible = true;
        },
        //设置
        onSetUp(data) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.ctrl.dialogTitle = data.username + " 设置";
            this.ctrl.attributesDialogVisible = true;
        },
        //备注
        onRemarks(data) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.ctrl.dialogTitle = data.username + " 备注信息";
            this.ctrl.remarksVisible = true;
        },
        //用户个人信息
        onUserInfi(data) {
            this.loading = true;
            apis.admin({ user_id: data.id }).then(res => {
                this.loading = false;
                if (res.code === 0) {
                    this.formData = res.data;
                    this.ctrl.dialogTitle = data.username + " 个人信息";
                    this.ctrl.userinfoVisible = true;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        //跳转到充值记录
        omRechargerecord(data) {
            this.$router.push({
                path: "/userList/rechargerecord?admin_id=" + data.id
            });
        },
        //查看监控数据
        viewMonitoring(data) {
            this.$router.push({
                path: "/keywords/index?admin_id=" + data.id
            });
        },
        //赠送信用度
        lineOfCredit(data) {
            let obj = {};
            obj.admin_id = data.id;
            obj.credit = data.credit_limit;
            this.creditindex = data.credit_limit;
            this.formData = obj;
            this.ctrl.dialogTitle = "给 " + data.username + " 修改信用额度";
            this.ctrl.acreditVisible = true;
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.addDialogVisible = false;
            this.ctrl.remarksVisible = false;
            this.ctrl.userinfoVisible = false;
            this.ctrl.acreditVisible = false;
            this.ctrl.attributesDialogVisible = false;
            if (isshow) return;
            this.getList();
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 165 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        164 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    }
};
</script>

<style type="text/scss" lang="scss">
.chcek_group {
    margin: 0 10px;
    color: #424f63;
    text-decoration: underline;
}
.chcek_group:hover {
    cursor: pointer;
}
</style>
